import script from "./SupervisaoMudarNivel.vue?vue&type=script&setup=true&lang=js"
export * from "./SupervisaoMudarNivel.vue?vue&type=script&setup=true&lang=js"

import "./SupervisaoMudarNivel.vue?vue&type=style&index=0&id=1e7a1884&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e7a1884"]])

export default __exports__